<script setup>
const close = {
  text: '閉じる',
  link: '',
  isActive: true
}

const props = defineProps({
  imageUploaded: '',
  selectedCitycode: '',
  error: ''
})

const attentionText = ref('')
if(props.imageUploaded && !props.selectedCitycode) {
  attentionText.value = '撮影場所'
} else if(!props.imageUploaded && props.selectedCitycode) {
  attentionText.value = '画像'
} else if(!props.imageUploaded && !props.selectedCitycode) {
  attentionText.value = '画像・撮影場所'
}

</script>

<template>
  <div v-if="error=='postFailed'&&(!imageUploaded||!selectedCitycode)" class="errorModal">
    <div class="box">
      <div class="head">
        <p class="heading">{{attentionText}}を入れてください</p>
        <p class="lead">{{attentionText}}を選択して再度送信をお願いいたします</p>
      </div>
      <div class="button">
        <CommonButton @click="$emit('closeModal',submitStatus)" :button="close"></CommonButton>
      </div>
    </div>
  </div>
  <div v-else-if="error=='postFailed'&&(imageUploaded&&selectedCitycode)" class="errorModal">
    <div class="box">
      <div class="head">
        <p class="heading">画像の送信に失敗しました</p>
        <p class="lead">申し訳ございません<br>時間をおいて再度送信をお願いいたします</p>
      </div>
      <div class="button">
        <CommonButton @click="$emit('closeModal',submitStatus)" :button="close"></CommonButton>
      </div>
    </div>
  </div>
  <div v-else-if="error=='noHistory'" class="errorModal">
    <div class="box">
      <div class="head">
        <p class="heading">解析結果はありません。</p>
        <p class="lead">桜AI開花予想トップからつぼみ画像の解析が可能です。</p>
      </div>
      <div class="button">
        <CommonButton @click="$emit('closeModal',submitStatus)" :button="close"></CommonButton>
      </div>
    </div>
  </div>
  <div v-else-if="error=='invalidFileDetected'" class="errorModal">
    <div class="box">
      <div class="head">
        <p class="heading">無効な形式のファイルが登録されました。</p>
        <p class="lead">つぼみの解析は画像ファイルのみ対応しています。</p>
      </div>
      <div class="button">
        <CommonButton @click="$emit('closeModal',submitStatus)" :button="close"></CommonButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.errorModal {
  @include flex-column();
  align-items: center;
  justify-content: center;
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100svh;
  padding: 10px;
  background-color: rgb(0 0 0 / .5);
  .box {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    padding: 30px 15px;
    width: 100%;
    border-radius: 12px;
    background-color: $white;
    box-shadow: 0 4px 6px 0 rgb($shadow, .25);
  }
  .head {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .heading {
    color: $strong;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.35em;
  }
  .lead {
    color: $font;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.5em;
  }
  .button {
    width: 150px;
  }
}
</style>
